import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit } from 'react-icons-kit/md';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import Create from "./models/CreateNote";
import ConfirmDelete from "./models/ConfirmDelete";
import Edit from "./models/EditNote";
import {
  NOTE_REQUEST,
  NOTE_CREATE,
  NOTE_DELETE,
  NOTE_EDIT,
  NOTE_STATE_CHANGE,

} from "../../../../_utils/constants/ProductCatalog";

import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const Note = ({
  auth: { auth, isAuthenticated },
  Note: { valueList, isCreated, isDeleted, isEdited, isLoading },

  fetchNote,
  submitNoteCreate,
  submitNoteDelete,
  submitNoteEdit,
  changeReducerState,

}) => {

  // states declarations
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [salesNoteName, setNoteName] = useState('');
  const [sortOrder, setSortOrder] = useState("");
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [deleteNoteId, setDeleteNoteId] = useState('');
  const [show, setShow] = useState(false);
  const [ids, setIds] = useState("");
  const [state, setState] = useState({
    "notesId": "",
    "notes": "",
    "notesDetailFor": "",
    "noteForPersonId": "",
    "creationComment": "",
  }
  )
  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchNote(auth[0].token);
    }
  }, [auth, isAuthenticated]);



  // use effect function called after api success
  useEffect(() => {
    if (isCreated === true) {
      toast.success("Note Created Successfully.");
      fetchNote(auth[0].token);
      changeReducerState();
    }
    if (isDeleted === true) {
      toast.success("Note Deleted Successfully.");
      fetchNote(auth[0].token);
      changeReducerState();
    }
    if (isEdited === true) {
      toast.success("Note Data Updated Successfully.");
      fetchNote(auth[0].token);
      changeReducerState();
    }
  }, [isCreated, isDeleted, isEdited]);


  const handleChange = (e) => {
    const { id, value } = e.target;
    setState({ ...state, [id]: value })

  }

  // function to open create modal
  const showCreateModal = () => {
    setCreateModalOpen(true);
  };

  // function to close create modal
  const hideCreateModal = () => {
    setCreateModalOpen(false);
    setShow(false)
    setIds("");
    setState({
      "notesId": "",
      "notes": "",
      "notesDetailFor": "",
      "noteForPersonId": "",
      "creationComment": "",

    })
  };

  // function called for input value change of create modal
  const handleSalesStageNameChange = (e) => {
    setNoteName(e.target.value);
  }
  const handleSortOrderChange = (e) => {
    setSortOrder(e.target.value);
  }

  // function called for create sales stage create api
  const handleCreateModalSubmit = (e) => {
    e.preventDefault();
    if (state.phoneType === '') {
      toast.error("NoteType cannot be empty.");
    } else {
      submitNoteCreate({
        "data": {
          "Notes": state.notes,
          "NotesDetailFor": state.notesDetailFor,
          "NoteForPersonId": parseInt(state.noteForPersonId),
          "CreationComment": state.creationComment,
          "CreatedBy": auth[0].userId,
        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeleteNoteId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeleteNoteId('');
    setConfirmDeleteModal(false);
  };

  // function called for delete sales stage delete api
  const handleConfirmDeleteSubmit = () => {
    submitNoteDelete({
      "NotesId": deleteNoteId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }

  // function called on edit icon click
  const handleEditClick = (data) => {
    setState(data);
    setIds(data.notesId);
    setShow(true)
  }

  // function called to save edited data
  const handleEditSaveClick = (data) => {
    if (state.notes === '') {
      toast.error("NoteType cannot be empty.");
    } else {
      submitNoteEdit({
        "data": {
          "NotesId": ids,
          "Notes": state.notes,
          "NotesDetailFor": state.notesDetailFor,
          "NoteForPersonId": parseInt(state.noteForPersonId),
          "CreationComment": state.creationComment,

        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <MainWrapper>
      <Loader loading={isLoading}>
        <div className="container">

          <div className="sub-header mt-5 mb-3">
            <h2>Note</h2>
            <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
            <Create
              variant="primary"
              title={`Note`}
              createModalOpen={createModalOpen}
              showCreateModal={showCreateModal}
              hideCreateModal={hideCreateModal}
              salesStageName={salesNoteName}
              handleSalesStageNameChange={handleSalesStageNameChange}
              sortOrder={sortOrder}
              handleSortOrderChange={handleSortOrderChange}
              handleCreateModalSubmit={handleCreateModalSubmit}
              handleChange={handleChange}
              state={state}

            />
          </div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>NoteType</th>
                <th className="text-center">Area Code</th>
                <th width="50" className="actions">
                  <div className="d-flex">
                    <span>Edit</span>
                    <span>Delete</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {valueList && valueList.length > 0 ? (
                valueList.map((item, index) => (

                  <tr key={index}>
                    <td>
                      {item.notes}
                    </td>
                    <td width="150">
                      {item.notesDetailFor}
                    </td>
                    <td className="actions">
                      <div className="btn-group">
                        <Icon role="button" className="mt-2 w-54 d-flex justify-content-center" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
                        <ConfirmDelete variant="primary" title={`Note`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.notesId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
                      </div>
                    </td>
                  </tr>

                ))
              ) : (
                <tr>
                  <td colSpan={4}>
                    No Data Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Loader>
      <Edit
        state={state}
        handleChange={handleChange}
        handleEditSaveClick={handleEditSaveClick}
        show={show}
        hideCreateModal={hideCreateModal}
        title={`Note`}
      />
    </MainWrapper>
  )
}

const mapStateToProps = ({ auth, Note }) => {
  return {
    auth,
    Note,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {

    fetchNote: (token) => dispatch({ type: NOTE_REQUEST, token }),
    submitNoteCreate: (data) => dispatch({ type: NOTE_CREATE, payload: data }),
    submitNoteDelete: (data) => dispatch({ type: NOTE_DELETE, payload: data }),
    submitNoteEdit: (data) => dispatch({ type: NOTE_EDIT, payload: data }),
    changeReducerState: () => dispatch({ type: NOTE_STATE_CHANGE }),


  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Note);